import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class DragScroll extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.state = {
      dragging: false
    }

    this.mouseUpHandle = () => {
      if (this.state.dragging) this.setState({dragging: false})
    }

    this.mouseDownHandle = (e) => {
      if (!this.state.dragging) {
        this.setState({dragging: true})
        this.lastClientX = e.clientX
        this.lastClientY = e.clientY
        e.preventDefault()
      }
    }

    this.mouseMoveHandle = (e) => {
      if (this.state.dragging) {
        this.container.scrollLeft -=
          (-this.lastClientX + (this.lastClientX = e.clientX))
        this.container.scrollTop -=
          (-this.lastClientY + (this.lastClientY = e.clientY))
      }
    }
  }

  componentDidMount() {
    window.addEventListener('mouseup', this.mouseUpHandle)
    window.addEventListener('mousemove', this.mouseMoveHandle)
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.mouseUpHandle)
    window.removeEventListener('mousemove', this.mouseMoveHandle)
  }

  render() {
    return (
      <div className={this.props.className}
           onMouseUp={this.mouseUpHandle}
           onMouseMove={this.mouseMoveHandle}
           onMouseDown={this.mouseDownHandle}
           ref={(r) => {this.container = r}}
           style={{...this.props.style, cursor: '-webkit-grab'}}
      >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/DragScroll/DragScroll.js